import { render, staticRenderFns } from "./ClassroomStreamAnnounce.vue?vue&type=template&id=0b1e6a40&scoped=true&"
import script from "./ClassroomStreamAnnounce.vue?vue&type=script&lang=js&"
export * from "./ClassroomStreamAnnounce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1e6a40",
  null
  
)

export default component.exports